import ClientPortal from '../../../plugins/axios'

export default {
    consultationMemberInfo(membn) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/consultation/memberInfo`, membn, 
            { withCredentials: true }
        )
    },
    verifyOppa(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/consultation/verify`, payload, 
            { withCredentials: true })
    },
    fetchOppaSlip(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/consultation/download`, payload,
            { withCredentials: true }
        )
    },
    history(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/consultation/history`, payload,
            { withCredentials: true }
        )
    },
    historyView(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/consultation/history/view`, payload,
            { withCredentials: true }
        )
    },

    userMBL(payload) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/util/annualMBL`,
            payload,
            { withCredentials: true }
        )
    },
  
    userAREHB(payload) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/util/arEHB`,
            payload,
            { withCredentials: true }
        )
    },
    specialization() {
        return ClientPortal.get(`${process.env.VUE_APP_API}/login/specializations`,
            { withCredentials:true }
        )
    },

    eligibleOP(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/consultation/eligible`, 
            payload,
            { withCredentials : true }
        )
    },
    eligibleAPE(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/consultation/eligibleAPE`,
            payload,
            { withCredentials: true }
        )
    },
    
    relatedList(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/consultation/getPrinDep`, 
            payload,
            { withCredentials: true }
        )
    },

    hospClinConsu(payload) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/login/hospClinConsu`,
            payload,
            { withCredentials: true }
        )
    }
}
